import React, { useRef } from "react";

import bannerHomeCare from "../../shared/img/bannerhomecare.jpg";
import Header from "../../shared/components/common/Header";
import MapAndCardsHomeCare from "../../shared/components/common/MapAndCardsHomeCare";
import InfoGrid from "./InfoGridHomeCare";
import GridHomeCare from "./gridHomecare";
import HeroCardContent from "./heroCardContent";
import ContactDrawer from "../../shared/components/common/ContactDrawer";
import { phoneWhatsapp } from "../../shared/config/phone";

export default function HomeCare() {
  const mapSectionRef = useRef(null);

  const scrollToMapAndCards = () => {
    mapSectionRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div className="bg-[#f3f6f8]">
      <Header onContactClick={scrollToMapAndCards} />

      <section
        className="relative h-[800px] sm:h-[850px] md:h-[800px] flex items-start justify-center px-4 pt-32"
        style={{
          backgroundImage: `url(${bannerHomeCare})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="w-full max-w-5xl bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg p-3 flex items-center justify-between pointer-events-auto mt-10 mx-4">
          <div className="pl-8">
            <p className="text text-gray-900">Precisa de Ajuda?</p>
            <p className="text-sm text-gray-400">Formulário • Contato</p>
            <p className="text-sm text-gray-400">08:00 • 18:00</p>
          </div>

          <div className="d-flex flex-row">
            <p className="hidden md:block text-sm text-gray-400 max-w-md px-2">
              Não consegue encontrar exatamente o que procura?
            </p>
            <p className="hidden md:block text-sm text-gray-400 max-w-md px-2">
              Entre em contato com os nossos atendentes treinados para te guiar
              na sua escolha para o melhor do seu tratamento.
            </p>
          </div>

          <a
            className="bg-black text-white font-bold text mr-8 px-4 py-1 rounded-full hover:bg-gray-800 transition-colors whitespace-nowrap pointer-events-auto"
            href={`https://wa.me/${phoneWhatsapp}?text=${encodeURIComponent(
              `Olá, tudo bem? Eu estava na página "Home Care - Bianco Azure" e gostaria de conversar com vocês.`
            )}`}
          >
            Entrar em contato
          </a>
        </div>

        <HeroCardContent />
      </section>

      <GridHomeCare />
      <InfoGrid />

      {/* 👇 aqui o ref correto */}
      <div ref={mapSectionRef}>
        <MapAndCardsHomeCare />
      </div>

      <ContactDrawer message="Vim do site, queria saber mais sobre HomeCare" />
    </div>
  );
}
